export enum DistributionRecipientStatus {
    active = 'ACTIVE',
    deleted = 'DELETED'
}
